import { AuthClient } from 'lib/auth-client';
import * as userProvider from 'lib/auth-client/auth-client/client-side-user-provider';
import emitter from './emitter';

export default new AuthClient({
  customerWebsiteBaseUrl: process.env.REACT_APP_CUSTOMER_WEBSITE_URL,
  userProvider,
  emitter: emitter,
});
